import firebase from '../config';
import { createStore, applyMiddleware, compose } from 'redux';
import { rootReducer } from './reducers';
import middlewares from './middleware';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { reduxFirestore } from 'redux-firestore'

// service workers
const composeEnhancers = typeof window !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

export default function configureStore() {
  const createStoreWithDevTools = window.devToolsExtension
    ? window.devToolsExtension()(createStore)
    : createStore;

  const createStoreWithMiddlewares = applyMiddleware(...middlewares)(createStoreWithDevTools);

  return createStoreWithMiddlewares(
    rootReducer()
  );
}

export const store = createStore(
  rootReducer,
  composeEnhancers(
    responsiveStoreEnhancer,
    applyMiddleware(...middlewares),
    reduxFirestore(firebase)
  )
);
